export default {
  namespaced: true,
  state: {
    queryList: {}
  },
  mutations: {
    setQueryList (state, val) {
      state.queryList[Object.keys(val)[0]] = val[Object.keys(val)[0]]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/queryCriteria.js